import React from 'react';
import { useNavigate } from 'react-router-dom';

function HesapBilgileriPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Hesap Bilgilerimiz</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-5xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-bold text-[#1e5a8e] mb-6">Banka Hesap Bilgileri</h2>
          
          <div className="space-y-6">
            <div className="border-b pb-4">
              <h3 className="font-bold text-gray-700 mb-2">Türkiye İş Bankası</h3>
              <p className="text-gray-600">IBAN: TR00 0000 0000 0000 0000 0000 00</p>
              <p className="text-gray-600">Hesap Adı: Meksa Yatırım Menkul Değerler A.Ş.</p>
            </div>
            
            <div className="border-b pb-4">
              <h3 className="font-bold text-gray-700 mb-2">Garanti BBVA</h3>
              <p className="text-gray-600">IBAN: TR00 0000 0000 0000 0000 0000 00</p>
              <p className="text-gray-600">Hesap Adı: Meksa Yatırım Menkul Değerler A.Ş.</p>
            </div>
            
            <div className="bg-yellow-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">
                <strong>Not:</strong> Para transferi yaparken açıklama kısmına mutlaka TC Kimlik numaranızı yazmanız gerekmektedir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HesapBilgileriPage;
